import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import { USER_ROLES } from '../../constants';
import UserForm from '../UserForm/UserForm';
import validate from '../../utils/validate';
import { createUserFormYopValidation } from '../UserForm/validation';
import { createUser } from '../../redux/user-management/userManagementActions';
import CommonPage from '../../components/common-page/CommonPage';

const CreateUser = () => {
  const dispatch = useDispatch();
  const createUserInitialValues = {
    name: '',
    email: '',
    password: '',
    repeatPassword: '',
    roleName: USER_ROLES.GLOBAL_ADMIN,
  };

  const handleCreateUser = useCallback(
    (values) => {
      dispatch(createUser(values));
    },
    [dispatch],
  );

  return (
    <CommonPage>
      <Form
        initialValues={createUserInitialValues}
        onSubmit={handleCreateUser}
        validate={(values) => validate(values, createUserFormYopValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <UserForm handleSubmit={handleSubmit} isCreate />}
      />
    </CommonPage>
  );
};

export default CreateUser;
